import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
//
import messages from 'constants/messages';
import { capitalizeFirstLetter } from 'lib/helpers/string-manipulators';

/**
 * Accepts an Error object or string, clears existing
 * toast messages, and then displays a new error toast
 *
 * @param error Error object or string
 * @returns void
 */
export function handleError(error: Error | string) {
  // Clear any existing toast messages
  toast.dismiss();

  // Determine output message
  let message;

  if (typeof error === 'object' && error !== null && error.message) {
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  } else {
    message = messages.errors.default;
  }

  // Show
  toast.error(message);
}

/**
 * Extracts error message from Axios payload, unless regular Error is passed
 *
 * @param error An AxiosError or standard Error object
 * @returns String message of error
 */
export function getAxiosErrorMessage(error: AxiosError): string {
  let message = messages.errors.default;

  if (error.message) {
    message = capitalizeFirstLetter(error.message);
  }

  return message;
}
